import { withStyles } from '@material-ui/core';

import SingleReceiptForm from './component';
import styles from './styles';

export default withStyles(styles)(SingleReceiptForm);
